import React, { FC, useState, ChangeEvent, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import styles from './range-input.module.scss';

interface RangeInputProps {
  label?: string;
  className?: string;
  onMinChange: (value: string) => void;
  onMaxChange: (value: string) => void;
  onBlurMin?: () => void;
  onBlurMax?: () => void;
  minValue?: string;
  maxValue?: string;
  disabled?: boolean;
}

const RangeInput: FC<RangeInputProps> = ({
                                           label,
                                           onMinChange,
                                           onMaxChange,
                                           className = '',
                                           onBlurMin,
                                           onBlurMax,
                                           minValue = '',
                                           maxValue = '',
                                           disabled = false
}) => {
  const { t } = useTranslation();
  const [minInputValue, setMinInputValue] = useState<string>(minValue);
  const [maxInputValue, setMaxInputValue] = useState<string>(maxValue);

  useEffect(() => {
    setMinInputValue(minValue);
  }, [minValue]);

  useEffect(() => {
    setMaxInputValue(maxValue);
  }, [maxValue]);

  const handleMinChange = (event: ChangeEvent<HTMLInputElement>) => {
    let value = event.target.value;
    value = value.replace(/\D/g, '');
    setMinInputValue(value);
    onMinChange(value);
  };

  const handleMaxChange = (event: ChangeEvent<HTMLInputElement>) => {
    let value = event.target.value;
    value = value.replace(/\D/g, '');
    setMaxInputValue(value);
    onMaxChange(value);
  };

  const handleResetMin = () => {
    setMinInputValue('');
    onMinChange('');
  };

  const handleResetMax = () => {
    setMaxInputValue('');
    onMaxChange('');
  };

  return (
      <>
        {label && <label className={styles.label}>{label}</label>}
        <div className={styles.inputContainer}>
          <div className={styles.inputWrapper}>
            <input
                placeholder={t('range-input.min')}
                value={minInputValue}
                onChange={handleMinChange}
                disabled={disabled}
                className={`${styles.input} ${minInputValue ? styles.filled : ''} ${className}`}
                onBlur={onBlurMin}
            />
            {minInputValue && (
                <button disabled={disabled} onClick={handleResetMin} className={styles.resetButton}></button>
            )}
          </div>
          <div className={styles.inputWrapper}>
            <input
                placeholder={t('range-input.max')}
                value={maxInputValue}
                onChange={handleMaxChange}
                disabled={disabled}
                className={`${styles.input} ${maxInputValue ? styles.filled : ''} ${className}`}
                onBlur={onBlurMax}
            />
            {maxInputValue && (
                <button disabled={disabled} onClick={handleResetMax} className={styles.resetButton}></button>
            )}
          </div>
        </div>
      </>
  );
};

export default RangeInput;
